export default {"src":"/_next/static/media/uptrendCta.05d10aec.svg","height":72,"width":110,"blurWidth":0,"blurHeight":0};